import React from 'react';
import ReactMarkdown from 'react-markdown';

interface ArticleContentProps {
  content: string;
}

const ArticleContent: React.FC<ArticleContentProps> = ({ content }) => {
  return (
    <article className="prose prose-lg max-w-none">
      <ReactMarkdown
        components={{
          img: ({ src, alt }) => (
            <img 
              src={src} 
              alt={alt} 
              className="w-full rounded-lg my-8"
              loading="lazy"
            />
          ),
          h1: ({ children }) => (
            <h1 className="text-4xl font-bold mb-8">{children}</h1>
          ),
          h2: ({ children }) => (
            <h2 className="text-3xl font-bold mt-12 mb-6">{children}</h2>
          ),
          h3: ({ children }) => (
            <h3 className="text-2xl font-bold mt-8 mb-4">{children}</h3>
          ),
          p: ({ children }) => (
            <p className="text-gray-600 mb-6 leading-relaxed">{children}</p>
          ),
          ul: ({ children }) => (
            <ul className="space-y-3 mb-6 ml-6">{children}</ul>
          ),
          li: ({ children }) => (
            <li className="flex items-start">
              <span className="w-1.5 h-1.5 rounded-full bg-gray-400 mt-2.5 mr-3 flex-shrink-0" />
              <span>{children}</span>
            </li>
          ),
          strong: ({ children }) => (
            <strong className="font-bold text-gray-900">{children}</strong>
          )
        }}
      >
        {content}
      </ReactMarkdown>
    </article>
  );
};

export default ArticleContent;